import { render } from "./MWBackground.vue?vue&type=template&id=5869c1a9"
import script from "./MWBackground.vue?vue&type=script&lang=js"
export * from "./MWBackground.vue?vue&type=script&lang=js"

import "./MWBackground.vue?vue&type=style&index=0&id=5869c1a9&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__